import {Box, useMediaQuery} from '@mui/material';
import {useAppDispatch, useAppSelector} from '@/store/hooks';
import {getAuctionCategories, getAuctionWonList} from '@/store/organization-auction';
import {toast} from 'react-toastify';
import {getErrorMessage} from '@/utils/helpers';
import {useEffect, useState} from 'react';
import WinnerTable from '@/components/Organization/AuctionEntry/AuctionWinnerTable/WinnerTable';
import Loader from '@/shared/components/Loader';
import {auctionStyle} from '../Auction/Auction.styles';
import {getCurrentEventSelector, getEventsSelector} from '@/store/organization-event';
import EmptyContent from '@/shared/components/Table/EmptyContent';
import {ReactComponent as PeopleIcon} from '@/assets/icons/sidebar/people.svg';
import {defaultPageSize} from '@/utils/constants';
import {AuctionEntryStyle} from './AuctionEntryStyle.styles';
import {orgAPI} from '@/core/api';

const AuctionEntry = () => {
	const dispatch = useAppDispatch();

	const events = useAppSelector(getEventsSelector);
	const event = useAppSelector(getCurrentEventSelector);

	const isLaptop = useMediaQuery('(min-width:1200px)');

	const [isDataLoaded, setIsDataLoaded] = useState(false);

	const getAuctionListData = async () => {
		if (!event?.id) return;

		setIsDataLoaded(false);
		try {
			const reqBody = {
				eventId: event?.id as number,
				page: 1,
				pageSize: isLaptop ? defaultPageSize : 10000,
			};

			await Promise.all([
				dispatch(getAuctionWonList({id: +event?.id, reqBody})).unwrap(),
				dispatch(getAuctionCategories(orgAPI)).unwrap(),
			]);
		} catch (error) {
			toast.error(getErrorMessage(error));
		} finally {
			setIsDataLoaded(true);
		}
	};

	useEffect(() => {
		if (!event?.id) {
			if (events && !events.length) setIsDataLoaded(true);
			return;
		}

		if (event?.id) getAuctionListData();
	}, [event?.id]);

	return (
		<Box sx={AuctionEntryStyle.containerWrapper}>
			{isDataLoaded ? (
				events?.length && event ? (
					<WinnerTable isDataLoaded={isDataLoaded} />
				) : (
					<EmptyContent title="You do not have any attendees." icon={PeopleIcon} />
				)
			) : (
				<Loader parentClassName={auctionStyle.loader} size={50} />
			)}
		</Box>
	);
};

export default AuctionEntry;
